var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 1V0H0V1V2V4V9V11V12V14V15V17V18V20V21V23V24H1H23H24V23V21V20V18V17V15V14V12V11V9V4V2V1ZM23 4V2H18V4H23ZM17 4V2H12V4H17ZM11 4V2H6V4H11ZM5 4V2H1V4H5ZM15.5 8.5L8.00001 16L10 18L17.5 10.5L15.5 8.5ZM1 6H23V22H1V6ZM7.50001 16.4999L6.5 19.4999L9.50001 18.5L7.50001 16.4999Z",
    fill: "#313131"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomTable);
export default __webpack_public_path__ + "static/media/CustomTable.92824579d578cd6fc8882dfa83bc852d.svg";
export { ForwardRef as ReactComponent };